export default class SearchEngineOptimization {
  title: string;
  description: string;
  keywords: string[];
  noIndex: boolean;
  noFollow: boolean;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.noIndex = data.noIndex || data.no_index;
    this.noFollow = data.noFollow || data.no_follow;
  }
}
